import { FC, useCallback } from 'react';
import cancelSurveyModalClass from '../../assets/scss/CancelSurveyModal/CancelSurveyModal.module.scss';
import { CancelSurveyModalViewType } from '../../types/view/CancelSurveyModalViewType';
import { CommonModal } from '../CommonModal';
import { postMessageGtag } from '../../utils/trackClick';
import { BottomButton } from '../ModalItem/BottomButton';

export const CancelSurveyModal: FC<{
  active: boolean;
  closeFunc: () => void;
  cancelSurveyModal: CancelSurveyModalViewType | null;
  clickSelectFunc: (num: number) => void;
  changeExtraFiledFunc: (text: string) => void;
  clickSubmitFunc: () => void;
  loading: boolean;
}> = ({
  active,
  closeFunc,
  cancelSurveyModal,
  clickSelectFunc,
  changeExtraFiledFunc,
  clickSubmitFunc,
  loading,
}) => {
  const clickSelectHandler = useCallback(
    (idx) => {
      clickSelectFunc(idx);
    },
    [clickSelectFunc]
  );

  const changeExtraFieldHandler = useCallback(
    (e) => {
      changeExtraFiledFunc(e.target.value);
    },
    [changeExtraFiledFunc]
  );

  const clickCancelHandler = useCallback(() => {
    closeFunc();
  }, [closeFunc]);

  const clickSubmitHandler = useCallback(() => {
    clickSubmitFunc();
  }, [clickSubmitFunc]);

  if (!cancelSurveyModal) return <></>;

  const reasonsHtml = cancelSurveyModal.reasons.map((reason, idx) => {
    return (
      <div
        key={`cancelReason-${idx}`}
        className={cancelSurveyModalClass.reasonContainer}
      >
        <div
          className={
            reason.selected
              ? `${cancelSurveyModalClass.selectCircle} ${cancelSurveyModalClass.selected}`
              : cancelSurveyModalClass.selectCircle
          }
          onClick={(_) => clickSelectHandler(idx)}
        />
        <div
          className={cancelSurveyModalClass.text}
          onClick={(_) => clickSelectHandler(idx)}
        >
          {reason.text}
        </div>
      </div>
    );
  });

  const extraFieldHtml = cancelSurveyModal.hasExtraField ? (
    <div style={{ marginBottom: '30px' }}>
      <div className={cancelSurveyModalClass.title}>その他、ご意見やご要望をご記入ください</div>
      <textarea
        value={cancelSurveyModal.extraField}
        className={cancelSurveyModalClass.extraField}
        rows={2}
        onChange={changeExtraFieldHandler}
      />
    </div>
  ) : (
    <></>
  );

  const content = (
    <>
      <div>
        <div style={{ marginBottom: '20px' }}>
          <div className={cancelSurveyModalClass.title}>定期購買の解約</div>
          <div
            dangerouslySetInnerHTML={{
              __html: (cancelSurveyModal.leadText ?? '').replace(/\n/g, '<br />'),
            }}
            className={cancelSurveyModalClass.leadText}
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          {/* <div className={cancelSurveyModalClass.title}>解約理由について教えてください</div> */}
          {reasonsHtml}
        </div>
        {extraFieldHtml}
        <div className={cancelSurveyModalClass.btnContainer}>
          <BottomButton
            buttonTitle="定期を続ける"
            clickFunc={() => {
              clickCancelHandler();
              postMessageGtag('click_CancelPage_CancelCancel', 'preventCancel');
            }}
          />
          <button
            onClick={() => {
              clickSubmitHandler();
              postMessageGtag('click_CancelPage_Cancel', 'preventCancel');
            }}
            disabled={loading}
          >
            解約する
          </button>
        </div>
      </div>
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
    >
      {content}
    </CommonModal>
  );
};
